module.exports = "<md-button class=\"calendly-modal__close\" ng-click=\"$ctrl.close()\" aria-label=\"Close schedule a call dialog\"> <md-icon>close</md-icon> </md-button> <md-dialog-content layout=\"column\"> <iframe flex ng-src=\"{{$ctrl.link}}\"/> </md-dialog-content> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/calendlyLauncher/calendlyModal.html
// module id = 1445
// module chunks = 28